var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"landscape-only-banner"},[_c('div',{staticClass:"logo"}),_c('span',[_vm._v(_vm._s(_vm.$t('please-rotate-device')))]),_c('img',{attrs:{"src":require("./assets/images/rotate-device.gif")}})]),_c('transition',{attrs:{"name":"fade-views"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }